import httpClient from "./httpClient";

export function getReports(date) {
  return httpClient.get("/results", {
    params: { date },
  });
}
